import { render, staticRenderFns } from "./courseTable.vue?vue&type=template&id=061aa64c"
import script from "./courseTable.vue?vue&type=script&lang=js"
export * from "./courseTable.vue?vue&type=script&lang=js"
import style0 from "./courseTable.vue?vue&type=style&index=0&id=061aa64c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports